import React, { useState, useRef, useEffect } from "react";
import "./TeamSection.css";

const ExpertCard = ({ member }) => (
  <div className="expert-card">
    <div className="card-top">
      {member.image && (
        <img
          src={member.image}
          alt={member.name}
          className="profile-image"
        />
      )}

      <div className="card-top-text">
        <h2 className="expert-name">{member.name}</h2>

        <p className="expert-title">
          {member.title || member.specialty}
        </p>

        {member.email && (
          <a
            href={`mailto:${member.email}?subject=${encodeURIComponent("[acornon.kr] 출판 문의")}`}
            target="_blank" rel="noreferrer"
            className="expert-email"
          >
            {member.email}
          </a>
        )}
      </div>
    </div>
    <div className="card-bottom">
      <div className="info-block">
        {/* <h3>전문 분야</h3> */}
        <div className="skill-tags">
          {member.tags.map((tag) => (
            <span key={tag} className="tag">
              {tag}
            </span>
          ))}
        </div>
      </div>
      <div className="info-block">
        {/* <h3>주요 성과</h3> */}
        <ul>
          {member.achievements.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

const TeamSection = ({ title, data, layout = "carousel", show = 4 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const trackRef = useRef(null);
  const [cardWidth, setCardWidth] = useState(0);

  const scroll = 1;
  const totalItems = data.length;
  const isScrollable = totalItems > show;
  const maxScrollIndex = Math.max(0, totalItems - show);

  useEffect(() => {
    if (trackRef.current && trackRef.current.children[0]) {
      const firstCard = trackRef.current.children[0];
      const gap = 24;
      setCardWidth(firstCard.offsetWidth + gap);
    }
  }, [data]);

  const handlePrev = () => {
    if (!isScrollable) return;
    const newIndex = currentIndex - scroll;
    setCurrentIndex(newIndex < 0 ? maxScrollIndex : newIndex);
  };

  const handleNext = () => {
    if (!isScrollable) return;
    const newIndex = currentIndex + scroll;
    setCurrentIndex(newIndex > maxScrollIndex ? 0 : newIndex);
  };

  const renderContent = () => {
    if (layout === "grid") {
      return (
        <div className="team-grid-container">
          {data.map((member, index) => (
            <ExpertCard key={index} member={member} />
          ))}
        </div>
      );
    }

    return (
      <div className="team-slider-wrapper">
        <button
          onClick={handlePrev}
          className="slider-nav prev"
          disabled={!isScrollable}
        >
          <img
            src="./images/gray-arrow-down.png"
            style={{
              transform: "rotate(90deg)",
              width: "12px",
              height: "12px",
              filter:
                "brightness(0) saturate(100%) invert(62%) sepia(2%) saturate(2531%) hue-rotate(169deg) brightness(92%) contrast(91%)",
            }}
          ></img>
        </button>
        <div className="slider-container">
          <div
            className="slider-track"
            ref={trackRef}
            style={{ transform: `translateX(-${currentIndex * cardWidth}px)` }}
          >
            {data.map((member, index) => (
              <ExpertCard key={index} member={member} />
            ))}
          </div>
        </div>
        <button
          onClick={handleNext}
          className="slider-nav next"
          disabled={!isScrollable}
        >
          <img
            src="./images/gray-arrow-down.png"
            style={{
              transform: "rotate(90deg)",
              width: "12px",
              height: "12px",
              filter:
                "brightness(0) saturate(100%) invert(62%) sepia(2%) saturate(2531%) hue-rotate(169deg) brightness(92%) contrast(91%)",
            }}
          ></img>
        </button>
      </div>
    );
  };

  return (
    <section className="team-section">
      <h1 className="team-section-title">{title}</h1>
      {renderContent()}
    </section>
  );
};

export default TeamSection;
